/** CZY STRONA DZIAŁA LOKALNIE (yarn run develop) => WTEDY NIE WYSYŁAMY ANALITYKI NA PRODUKCJĘ */
export function isLocalhost(): boolean {
  // SSR => W GATSBY BUILD NIE MA WINDOW
  if (typeof window === 'undefined') return false;

  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');
}



// WEBPACK FOOTER //
// ./src/services/environment-service.ts